import React from "react";

export default function ComplianceIcon() {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.125 3.75H5.375V7.5H2.875V1.25H9.125V3.75ZM27.875 7.5V1.25H21.625V3.75H25.375V7.5H27.875ZM9.125 26.25H5.375V22.5H2.875V28.75H9.125V26.25ZM25.375 22.5V26.25H21.625V28.75H27.875V22.5H25.375ZM24.125 22.5C24.125 23.875 23 25 21.625 25H9.125C7.75 25 6.625 23.875 6.625 22.5V7.5C6.625 6.125 7.75 5 9.125 5H21.625C23 5 24.125 6.125 24.125 7.5V22.5ZM19.125 10H11.625V12.5H19.125V10ZM19.125 13.75H11.625V16.25H19.125V13.75ZM19.125 17.5H11.625V20H19.125V17.5Z"
        fill="#065B70"
      />
    </svg>
  );
}
